// Every `<Table>`'s chrome strings — the same on each screen, so built in one place.
export const buildTableLabels = (t) => ({
  search: t('TABLE_SEARCH'),
  rowsPerPage: t('TABLE_ROWS_PER_PAGE'),
  selected: t('TABLE_SELECTED'),
  clearSelection: t('TABLE_CLEAR_SELECTION'),
  rowActionsMenu: t('COMMON_MORE_ACTIONS'),
  filter: t('TABLE_FILTER'),
  filterTitle: t('TABLE_FILTER_TITLE'),
  apply: t('COMMON_APPLY'),
  reset: t('COMMON_RESET'),
  from: t('COMMON_FROM'),
  to: t('COMMON_TO'),
});
